export interface IAuthUserModel {
  id: string;
  nomeCompleto: string;
  userName: string;
  profilePicture: string;
  role: string;
  permissions: Array<string>;
  empresaId: number;
  tenantId: string;
  razaoSocial: string;
  versaoTeste: string;
  dataInadimplencia: string;
  especialidade?: string;
  carencia: string;
  dataBloqueio?: string;
  diasUteisRestantes?: string;
  deveMostrarAviso?: string;
  bloqueioAmanha?: string;
}

export default class AuthUserModel {
  public id: string;

  public nomeCompleto: string;

  public userName: string;

  public profilePicture: string;

  public role: string;

  public permissions: Array<string>;

  public empresaId: number;

  public tenantId: string;

  public razaoSocial: string;

  public versaoTeste: string;

  public dataInadimplencia: string;

  public especialidade?: string;

  public carencia: string;

  public dataBloqueio?: string;

  public diasUteisRestantes?: string;

  public deveMostrarAviso?: string;

  public bloqueioAmanha?: string;

  constructor() {
    this.id = '';
    this.nomeCompleto = '';
    this.userName = '';
    this.profilePicture = '';
    this.role = '';
    this.permissions = [];
    this.empresaId = 0;
    this.tenantId = '';
    this.razaoSocial = '';
    this.versaoTeste = '';
    this.dataInadimplencia = '';
    this.especialidade = '';
    this.carencia = '';
    this.dataBloqueio = '';
    this.diasUteisRestantes = '';
    this.deveMostrarAviso = '';
    this.bloqueioAmanha = '';
  }
}
